module.exports = __webpack_public_path__ + "media/teams/trackprogress-c51d6398.png";